module.exports = __webpack_public_path__ + "files/e30ee77fc42fc6a7676b495440eb925b.png";